<button mat-raised-button
 (click)="syncQuestions()"
  matTooltip="Click here to sync questions from agency spreadsheet"
  matTooltipPosition="above"
  fxLayoutAlign="center center">
  <mat-icon [ngClass]="{'icn-spinner': syncing$ | async}">cached</mat-icon>
  Click to sync questions
</button>
